<template>
  <b-modal
    v-model="model"
    size="xl"
    centered
    title="Asignar Job"
    ok-title="Guardar"
    cancel-title="Cancelar"
    ok-variant="primary"
    :ok-disabled="!selectedJob || loading"
    @ok.prevent="handleSave"
    @show="initLocalLines"
  >
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="sm"
    >
      <b-form-group label="Job" label-for="assign-job-select">
        <BaseSelect
          id="assign-job-select"
          v-model="selectedJob"
          :resource="$data.$constants.RESOURCES.RESOURCE_JOBS"
          :http-body="jobFilters"
        />
      </b-form-group>

      <b-table
        :items="localLines"
        :fields="columns"
        responsive
        class="mt-1"
      >
        <template #cell(product)="{ item }">
          <span>{{ item.product ? item.product.name : '—' }}</span>
        </template>
        <template #cell(description)="{ item }">
          <span>{{ item.description }}</span>
        </template>
        <template #cell(amount)="{ item }">
          <span>{{ item.amount | numberToLocalString }} €</span>
        </template>
        <template #cell(units)="{ item, index }">
          <b-form-input
            v-model.number="localLines[index].units"
            type="number"
            :max="originalUnitsMap[item.id]"
            :min="0"
            size="sm"
          />
          <small v-if="originalUnitsMap[item.id] !== undefined" class="text-muted d-block">
            Máx. {{ originalUnitsMap[item.id] }}
          </small>
          <small v-if="localLines[index].units > originalUnitsMap[item.id]" class="text-danger d-block">
            No puede superar las unidades originales
          </small>
        </template>
        <template #cell(total)="{ item, index }">
          {{ (localLines[index].units * item.amount) | numberToLocalString }} €
        </template>
      </b-table>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'
import OrdersApi from '@/api/orders-api'

export default {
  name: 'AssignJobModal',
  components: { BaseSelect },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      selectedJob: null,
      localLines: [],
      originalUnitsMap: {},
      jobFilters: { filters: { status_open: true } },
      columns: [
        { label: 'PRODUCTO', key: 'product', sortable: false },
        { label: 'DESCRIPCIÓN', key: 'description', sortable: false },
        { label: 'IMPORTE', key: 'amount', sortable: false },
        { label: 'UNIDADES', key: 'units', sortable: false, thStyle: { 'min-width': '140px' } },
        { label: 'TOTAL', key: 'total', sortable: false },
      ],
    }
  },
  computed: {
    ...mapGetters('orders', {
      order: 'getOrder',
      orderLines: 'getOrderLines',
    }),
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    hasUnitsError() {
      return this.localLines.some(line => line.units > this.originalUnitsMap[line.id])
    },
  },
  methods: {
    initLocalLines() {
      this.selectedJob = null
      this.originalUnitsMap = {}
      this.localLines = this.orderLines.map(line => {
        this.$set(this.originalUnitsMap, line.id, Number(line.units))
        return { ...line, units: Number(line.units) }
      })
    },
    async handleSave() {
      if (!this.selectedJob?.id) {
        this.$toast.error('Debes seleccionar un job antes de guardar.')
        return
      }

      if (this.hasUnitsError) {
        this.$toast.error('Hay líneas con unidades superiores a las originales.')
        return
      }

      const payload = {
        order_id: this.order.id,
        job_id: this.selectedJob.id,
        lines: this.localLines.filter(line => Number(line.units) > 0).map(line => ({
          order_line_id: line.id,
          product_id: line.product?.id ?? null,
          description: line.description,
          units: line.units,
          amount: line.amount,
          total: parseFloat((line.units * line.amount).toFixed(2)),
        })),
      }

      this.loading = true
      try {
        const response = await OrdersApi.assignJob(payload)
        this.$toast('Job asignado correctamente.')
        this.model = false
        this.$emit('job-assigned', response.data)
      } catch (error) {
        const data = error.response?.data
        if (data?.message) {
          this.$toast.error(data.message)
        } else {
          this.$toast.error('Ocurrió un error al asignar el job. Por favor inténtelo de nuevo más tarde.')
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
